export default "__VITE_ASSET__DIMdqFIP__"